var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VResponsive',{attrs:{"aspect-ratio":_vm.aspectRatio,"min-height":156}},[(_vm.typeCode === 'file')?_c('video',{attrs:{"src":_vm.body,"controls":"","preload":"metadata"}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }